import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  InputBase,
  Select,
  MenuItem,
  Link,
  Checkbox,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { OpenInNew } from "@mui/icons-material";
import Organization from "../settings/Organization";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Account from "../settings/Account";
import Users from "../settings/Users";
import Billing from "../settings/Billing";

const Settings = () => {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <div className="pt-7 px-4">
      <div className="lg:text-[17px] text-[15px]  font-semibold">Settings</div>

      <div className="lg:bg-white rounded-[13px]  lg:min-h-[85vh] h-fit w-full my-5 py-5 lg:px-5 relative ">
        <div className="grid grid-cols-9  h-full ">
          <div className="lg:col-span-1 col-span-9 relative with-divider lg:space-y-3 w-full  flex lg:block mb-4 lg:mb-0">
            <div
              onClick={() => {
                navigate('/dashboard/settings/organization')
              }}
              className={
                location.pathname === "/dashboard/settings/organization" || location.pathname === "/dashboard/settings"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-black lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              Organization
            </div>
            <div
              onClick={() => {
                navigate('/dashboard/settings/account')
              }}
              className={
                location.pathname === "/dashboard/settings/account"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-black lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              My Account
            </div>
            <div
              onClick={() => {
                navigate('/dashboard/settings/users')
              }}
              className={
                location.pathname === "/dashboard/settings/users"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-black lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              Users
            </div>
            <div
              onClick={() => {
                navigate('/dashboard/settings/billing')
              }}
              className={
                location.pathname === "/dashboard/settings/billing"
                  ? "text-[#605BFF] bg-[rgba(96,91,255,0.1)] lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer "
                  : "text-black lg:rounded-[10px] py-1 px-2 lg:text-[15px] text-[13px] mr-2 cursor-pointer"
              }
            >
              Billing
            </div>
          </div>
          <div className="lg:col-span-8 col-span-9 lg:px-6 px- h-full w-full bg-white  ">
          <Routes>
              <Route path="/" element={<Organization/>} />
              <Route path="/organization" element={<Organization/>} />
              <Route path="/account" element={<Account/>} />
              <Route path="/users" element={<Users/>} />
              <Route path="/billing" element={<Billing/>} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
